export const QUERY_PARAM_TEXT = 'text' as const;
export const QUERY_PARAM_ASSIGNEE = 'assignees' as const;
export const QUERY_PARAM_ENVIRONMENT_NAME = 'environmentNames' as const;
export const QUERY_PARAM_EPIC = 'epics' as const;
export const QUERY_PARAM_ISSUE_TYPE = 'issueTypes' as const;
export const QUERY_PARAM_FIX_VERSION = 'fixVersions' as const;
export const QUERY_PARAM_START_DATE = 'startDate' as const;
export const QUERY_PARAM_END_DATE = 'endDate' as const;
